import {
  IconDashboard,
  IconInbox,
  IconShield,
  IconPackage,
  IconVault,
  IconClipboard,
  IconAlert,
  IconLayers,
  IconPlug,
  IconBuilding,
} from '../../ui/icons';
import { FEATURES } from '../../../config/features';
import { WorkspaceNav } from '../WorkspaceNav';

/**
 * Icon-rail navigation for the Provider workspace.
 * Routes/labels mirror ProviderSidebar — no route paths change.
 */
const sections = [
  {
    items: [
      { to: '/provider', label: 'Dashboard', Icon: IconDashboard, end: true },
      { to: '/provider/intake', label: 'Intake Explorer', Icon: IconInbox },
      { to: '/provider/authority-review', label: 'Authority Review', Icon: IconShield },
      { to: '/provider/packages', label: 'Packages', Icon: IconPackage },
    ],
  },
  {
    items: [
      { to: '/provider/assets', label: 'Assets', Icon: IconVault },
      { to: '/provider/custody-packaging', label: 'Custody packaging', Icon: IconClipboard },
      { to: '/provider/exceptions', label: 'Exceptions', Icon: IconAlert },
    ],
  },
  {
    items: [
      { to: '/provider/programs-rules', label: 'Programs & Rules', Icon: IconLayers },
      { to: '/provider/integrations', label: 'Integrations', Icon: IconPlug },
      ...(FEATURES.providerAdminConsole
        ? [
            { to: '/provider/admin/organizations', label: 'Admin', Icon: IconBuilding },
            { to: '/provider/admin/programs', label: 'Programs', Icon: IconLayers },
          ]
        : []),
    ],
  },
];

export function ProviderIconRail() {
  return <WorkspaceNav ariaLabel="Provider navigation" sections={sections} />;
}
